import script from "./ModalSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalSelect.vue?vue&type=script&setup=true&lang=js"

import "./ModalSelect.vue?vue&type=style&index=0&id=cce40664&lang=sass"

const __exports__ = script;

export default __exports__